import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./pages/Home/Home";
import FinanceOverview from "./pages/FinanceOverview/FinanceOverview";
import ManagerCheck from "./pages/ManagerCheck/ManagerCheck";
import ManagerComplete from "./pages/ManagerCompleted/ManagerCompleted";
import Unauthorized from "./pages/Unauthorized/Unauthorized";
import Supervisor from "./pages/Supervisor/Supervisor";
import Feedback from "./pages/Feedback/Feedback";

function App() {
  const router = createBrowserRouter([
    { path: "/", element: <Home /> },

    { path: "/finance", element: <FinanceOverview /> },

    { path: "/manager-check", element: <ManagerCheck /> },
    { path: "/manager-completed", element: <ManagerComplete /> },

    { path: "/supervisor", element: <Supervisor /> },

    { path: "/unauthorized", element: <Unauthorized /> },

    { path: "/feedback", element: <Feedback /> },

    { path: "*", element: <Unauthorized /> },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
